var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmega3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA6;}\n\t.st1{fill:#B3B3B3;}\n\t.st2{fill:#E7E5E5;}\n\t.st3{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,183.6c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.4,149.2,63.2,183.6,106,183.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.3,106.4c-2.3,0.5-4.8,1.2-6.5,3c-0.6,0.7-1.1,1.6-1.6,2.4c-1.2,2.1-2.4,4.1-3.6,6.2 c4.1,1.8,8.7,0,12.6-2.3c3.9-2.3,7.6-5.3,12-5.9c1-0.1,3-0.5,2.5-2.2c-0.3-1-2.2-1.6-3-2L62.3,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.3,106.4c-2.3-0.5-4.8-1.2-6.5-3c-0.6-0.7-1.1-1.6-1.6-2.4c-1.2-2.1-2.4-4.1-3.6-6.2 c4.1-1.8,8.7,0,12.6,2.3c3.9,2.3,7.6,5.3,12,5.9c1,0.1,3,0.5,2.5,2.2c-0.3,1-2.2,1.6-3,2L62.3,106.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129,99.3c-1.5-4-3-7.9-4.7-11.8c-0.9-1.9-1.8-3.9-3.4-5.3c-1,2.7-2,5.4-3.7,7.8c-1.7,2.3-4.2,4.2-7.1,4.5 c-0.5,0.1-1.2,0.1-1.4,0.6c-0.1,0.3-0.1,0.6-0.1,0.8c0.1,0.8,0.3,1.5,0.5,2.2c0.1,0.3,0.3,0.7,0.6,0.9c0.3,0.2,0.6,0.2,0.9,0.2 c6.1,0.3,12.3,0.6,18.4,0.9c-0.2-1.1-0.4-2.2-0.8-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.6,120.4c0.8,0.6,1.6,1.3,2.6,1.4c0.7,0.1,1.5-0.2,2.2-0.1c0.5,0.1,0.9,0.4,1.2,0.7 c0.2,0.2,0.3,0.5,0.6,0.7c0.4,0.2,0.9,0.1,1.3-0.2c2.4-1.3,3.9-3.8,5.2-6.1c0.3-0.5,0.6-1.1,0.4-1.6c-0.1-0.4-0.5-0.7-0.8-0.9 c-1.6-0.8-6.1-1.4-7.6-0.4c-0.9,0.6-1.4,1.8-2.2,2.5c-1.3,1.1-3,1.7-4.4,2.6C102.5,119.5,103.1,119.9,103.6,120.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.9,106.4c0.7-2.7,0.7-2.7-6.9-5.8c-8-3.3-38.1-6-49.4-3.1c-11.1,2.8-24.8,4.2-24.8,4.2s-5.5,0.5-6.5,0.4 c-0.9-0.1-3.8,3.2-2.7,5.1c1.1,2,4.2,3.3,9,3.2c4.8-0.1,14.4,4.8,20.7,6.3c6.3,1.5,19.6,5.4,31.8,3.5s31-9.1,31.5-11.7 C163.1,105.9,159.9,106.4,159.9,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.6,100.8c-10.1,1.1-16.1-0.6-37.8,0.3c-21.9,0.9-28.2,0.5-45.7,2.9c0.7-1.1,1.7-2,2.2-1.9 c0.9,0.1,6.5-0.4,6.5-0.4s13.7-1.4,24.8-4.2c11.3-2.8,41.5-0.2,49.4,3.1C153.2,100.7,153.4,100.8,153.6,100.8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.8,119.3c0,0-0.2,0.1-0.4,0.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmega3);
export default __webpack_public_path__ + "static/media/Omega_3.c086d70c647f1564f62e7560b706cdde.svg";
export { ForwardRef as ReactComponent };